/**
 * Mapping of field keys belonging to each campaign section
 */
export const SECTION_FIELDS_MAP = {
  campaign_info: [
    'name',
    'description',
    'product_link',
    'campaign_source',
    'channel',
    'total_creators',
    'min_followers',
    'min_gmv',
    'domicile',
    'product_type',
    'thumbnail',
    'product_category',
    'campaign_type',
    'start_date',
    'end_date',
  ],
  scope_of_works: [
    'content_type',
    'content_amount',
    'content_brief',
  ],
  agreements: [
    'commission_tap',
    'commission_mcn',
  ],
}

/**
 * Returns total count of invalid fields in a given section
 * @param {string} sectionKey
 * @param {Record<string, string[]>} errors
 * @returns {number}
 */
export const getSectionErrorCount = (sectionKey, errors) => {
  if (!errors) return 0
  const keys = SECTION_FIELDS_MAP[sectionKey] || []
  return keys.reduce((count, key) => {
    const errs = errors[key]
    return count + (Array.isArray(errs) && errs.length > 0 ? 1 : 0)
  }, 0)
}

/**
 * Handles form validation errors:
 * 1. Automatically expands all accordion sections that contain errors.
 * 2. Auto-scrolls smoothly to the first field that has an error.
 *
 * @param {Object} params
 * @param {Record<string, boolean>} params.sectionStates
 * @param {Record<string, string[]>} params.errors
 */
export const handleValidationErrors = ({ sectionStates, errors }) => {
  if (!errors || !sectionStates) return

  // 1. Auto-expand any accordion section that has errors
  Object.keys(SECTION_FIELDS_MAP).forEach(sectionKey => {
    if (getSectionErrorCount(sectionKey, errors) > 0) {
      if (sectionStates[sectionKey] !== undefined) {
        // eslint-disable-next-line no-param-reassign
        sectionStates[sectionKey] = true
      }
    }
  })

  // 2. Find the very first field with an error in field order
  const allFieldKeys = [
    ...SECTION_FIELDS_MAP.campaign_info,
    ...SECTION_FIELDS_MAP.scope_of_works,
    ...SECTION_FIELDS_MAP.agreements,
  ]

  const firstErrorKey = allFieldKeys.find(key => Array.isArray(errors[key]) && errors[key].length > 0)

  if (firstErrorKey) {
    // Delay slightly to allow the accordion expand animation to settle
    setTimeout(() => {
      const el = document.getElementById(firstErrorKey)
        || document.querySelector(`[name="${firstErrorKey}"]`)
        || document.querySelector(`[id="${firstErrorKey}"]`)
        || document.querySelector('.is-invalid')

      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        const inputEl = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT'
          ? el
          : el.querySelector('input, textarea, select, button')
        if (inputEl && typeof inputEl.focus === 'function') {
          inputEl.focus()
        }
      }
    }, 250)
  }
}
